export default __webpack_public_path__ + "0e06c7da8c5cfd6f3a44387d713ea89f.png";